// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__1SipW","control":"Checkout_control__f2X3B","actions":"Checkout_actions__rbARD","submit":"Checkout_submit__29C3p","invalid":"Checkout_invalid__2QoYp"};